import { Duration } from 'luxon';
import { useEffect, useState } from 'react';

export type DurationUnit = 'years' | 'months' | 'weeks' | 'days' | 'hours' | 'minutes' | 'seconds' | 'milliseconds';

const unitOptions: { value: DurationUnit; label: string }[] = [
  { value: 'years', label: 'year(s)' },
  { value: 'months', label: 'month(s)' },
  { value: 'weeks', label: 'week(s)' },
  { value: 'days', label: 'day(s)' },
  { value: 'hours', label: 'hour(s)' },
  { value: 'minutes', label: 'minute(s)' },
  { value: 'seconds', label: 'second(s)' },
  { value: 'milliseconds', label: 'millisecond(s)' },
];

function getDurationAmount(d: Duration): number {
  const unit = getDurationUnit(d);
  return d[unit];
}

function getDurationUnit(d: Duration): DurationUnit {
  if (d.years > 0) {
    return 'years';
  } else if (d.months > 0) {
    return 'months';
  } else if (d.weeks > 0) {
    return 'weeks';
  } else if (d.days > 0) {
    return 'days';
  } else if (d.hours > 0) {
    return 'hours';
  } else if (d.minutes > 0) {
    return 'minutes';
  } else if (d.seconds > 0) {
    return 'seconds';
  } else if (d.milliseconds > 0) {
    return 'milliseconds';
  } else {
    return 'days';
  }
}
export const DurationInput = ({
  value,
  onChange,
  allowedUnits = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'],
}: {
  value: Duration;
  onChange: (v: Duration) => void;
  allowedUnits?: DurationUnit[];
}) => {
  const [amount, setAmount] = useState<number>(getDurationAmount(value));
  const [unit, setUnit] = useState<DurationUnit>(getDurationUnit(value));

  useEffect(() => {
    if (unit && amount) {
      onChange(Duration.fromObject({ [unit]: amount }));
    }
  }, [amount, unit]);

  return (
    <div className="flex gap-2">
      <input
        type="number"
        value={amount}
        required={true}
        onChange={(e) => setAmount(parseInt(e.target.value))}
        data-cy="duration-input"
      />
      <select
        className="w-fit"
        value={unit}
        required={true}
        onChange={(e) => setUnit(e.target.value as DurationUnit)}
        data-cy="units-select"
      >
        {unitOptions
          .filter(({ value }) => allowedUnits.includes(value))
          .map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
      </select>
    </div>
  );
};
